import { useAtom } from "jotai";
import { useMemo } from "react";
import type { AnyAction } from "redux";
import { AllActionsEnum } from "../reducers/actions";
import { getActiveStep, stepHasGuidedMode } from "../services/questionnaire";
import { RootStore } from "../stores/app";

export function useGuidedMode() {
  const [rootStore, setRootStore] = useAtom(RootStore);
  const store: RootStoreModule.State = rootStore.updates;
  const activeStep = getActiveStep(store);

  return useMemo(() => {
    const hasGuidedMode = stepHasGuidedMode(activeStep);
    const guidedModeEnabled = Boolean(store.formValues.guidedMode);

    const showGuidedMode = (visible: boolean): AnyAction => {
      return setRootStore({ type: AllActionsEnum.SHOW_GUIDED_MODE, payload: { guidedMode: visible } });
    };

    return { hasGuidedMode, guidedModeEnabled, activeStepName: activeStep.stepname, showGuidedMode };
  }, [activeStep]);
}
